import type { CadAnalysisStatus } from "@/api/cad";

const STYLES: Record<CadAnalysisStatus, { label: string; className: string }> = {
  pending: { label: "Queued", className: "bg-amber-50 text-amber-700 border-amber-200" },
  running: { label: "Analyzing…", className: "bg-blue-50 text-blue-700 border-blue-200" },
  ready: { label: "Ready", className: "bg-green-50 text-green-700 border-green-200" },
  failed: { label: "Failed", className: "bg-red-50 text-red-700 border-red-200" },
};

export const Cad3dStatusChip = ({ status }: { status: CadAnalysisStatus | null }) => {
  if (!status) return null;
  const style = STYLES[status];
  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-0.5 text-xs font-medium ${style.className}`}
    >
      {(status === "pending" || status === "running") && (
        <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-current" />
      )}
      {style.label}
    </span>
  );
};
